"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var browser_1 = require("@sentry/browser");
var loadEnv_1 = require("src/Env/loadEnv");
var SAMPLE_RATE = 0.05;
var Sentry = {
    init: function (environment) {
        var envName = loadEnv_1.default().NAME;
        if (!['prod', 'usni', 'canary'].includes(envName)) {
            console.log("Sentry disabled in " + envName);
            return;
        }
        browser_1.init({
            release: 'rowan-ui@' + process.env.npm_package_version,
            dsn: 'https://c14f937b4044404b9affb64866841e25@sentry.io/1861325',
            environment: environment,
            attachStacktrace: true,
            enabled: process.env.DEFAULT_ENV !== 'test' && process.env.DEFAULT_ENV !== 'dev'
        });
        window.onerror = function (event, _source, _lineno, _colno, error) {
            Sentry.logError(error || new Error(event.toString()));
        };
    },
    logError: function (e) {
        console.error(e);
        if (Math.random() < SAMPLE_RATE) {
            browser_1.captureException(e);
        }
    }
};
exports.default = Sentry;
